
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { DownloadIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { Badge } from "types";
import { useNavigate } from "../../services";

type IShare = {
  badge: Badge | undefined
  certificates: Badge[] | undefined
}

export const Download = (
  { badge,certificates }:IShare
) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMedium = useMediaQuery(theme.breakpoints.down(950));

  const hasEnabledBadge = !!badge?.isEnable;
  const hasEnabledCertificate = !!certificates?.some(c => c?.isEnable);

  return (
    <Box
      id="button-download"
      role="button"
      className="button"
      aria-label={ t("download") }
      tabIndex={ 0 }
      position={ "relative" }
      sx={ {
        gap: "0.5rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "1rem 0.75rem",
        cursor: (hasEnabledBadge || hasEnabledCertificate) ? "pointer" :"not-allowed"
      } }
      alignItems="center"
      
      onClick={ (e)=> {
        if(hasEnabledBadge || hasEnabledCertificate){
          e.preventDefault();
          navigate("/profile");
        } else {
          e.preventDefault();
        }
      } }

    >
      <DownloadIcon size={ "1rem" } />
      { !isMedium && (
        <Typography fontSize={ "0.875rem" }>
          { t("Download") }
        </Typography>
      ) }
    </Box>
  );
};
